import React from "react";

function renderSectionTitle({ text }) {
  return (
    <div
      style={{
        textTransform: "uppercase",
        borderLeft: "2px solid grey",
        letterSpacing: "1mm",
        paddingLeft: "5px",
        backgroundColor: "#E6E7E7",
        width: "fit-content",
        fontSize: "small",
        marginBottom: "10px",
      }}
    >
      <b>{text}</b>
    </div>
  );
}

export default renderSectionTitle;
